// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1_krB","label":"LabeledBox_label__3EAuq"};